<template>
  <div class="CadastroUsuarios">
    <el-row class="el-row-topo">
      <el-col :span="24">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
          <el-breadcrumb-item>Editar Perfil</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>

    <el-row type="flex" justify="center">
      <el-col :span="24">
        <h1>Editar Perfil</h1>
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col :xs="24" :sm="24" :md="24" :lg="20" :xl="20">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          :label-position="labelPosition"
          class="demo-ruleForm"
        >
          <el-row :gutter="10">
            <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
              <el-form-item label="Nome" prop="nome">
                <el-input v-model="ruleForm.nome" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
              <el-form-item label="Usuário SGE" prop="sge_cod_usuario">
                <el-input v-model="ruleForm.sge_cod_usuario" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="10" :xl="10">
              <el-form-item label="Email" prop="email">
                <el-input v-model="ruleForm.email" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row> 
          <el-row :gutter="10">
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Entre com a Senha Atual" prop="pass">
                <el-input type="password" id="pass" v-model="ruleForm.pass" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row> 
          <el-row :gutter="10">
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Senha Nova" prop="pass">
                <el-input type="password" id="pass" v-model="ruleForm.pass" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Repita a Senha Nova" prop="checkPass">
                <el-input
                  type="password"
                  id="checkPass"
                  v-model="ruleForm.checkPass"
                  auto-complete="off"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-button type="primary" @click="submitForm('ruleForm')">Salvar</el-button>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import axios from "axios";
import FuncoesUteis from "../../plugins/FuncoesUteis";

// const url = "http://" + window.location.hostname + ":8000/api";
const url = '/api';

export default {
  data() {
    return {
      labelPosition: "right",
      dialogFormVisible: false,
      permissao: {},
      ruleForm: {
        nome: "",
        sge_cod_usuario: "",
        email: "",
        pass: "",
        checkPass: "",
      },
      rules: {
        nome: [
          {
            required: true,
            message: "Por Favor, informe o Nome",
            trigger: "blur",
          },
          {
            min: 3,
            message: "Deve ter pelo menos 3 caracteres",
            trigger: "blur",
          },
        ],
        email: [
          {
            type: "email",
            message: "Informe um e-mail válido.",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  mounted() {
    this.permissao = FuncoesUteis.isPermissao();
    if (!this.permissao.senha_user) {
      this.$message.error("Você não tem permissão para acessar esta página.");
      this.$router.push("/");
      return;
    }
    this.usuario = FuncoesUteis.getUsuario();
    const userId = this.usuario.id_usuario || 0;
    // console.log("userId: " + userId);
    axios
      .get(url + "/users_show/" + userId, {
        headers: {
          Authorization: "Bearer " + this.$store.state.token,
        },
      })
      .then((response) => {
        if (response.data.status == "Token is Expired" || response.data.status == "Token is Invalid" || response.data.status == "Authorization Token not found") {
          this.$store.dispatch("logout").then(() => {
            this.$router.push("/login");
          });
        } else {
          this.ruleForm.nome = response.data.nome;
          this.ruleForm.email = response.data.email;
          this.ruleForm.sge_cod_usuario = response.data.sge_cod_usuario;
        }
      })
      .catch((err) => {
        this.total = "erro" + err;
      });
  },
  methods: {
    //CADASTRO DADOS
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let dados = {
            nome: this.ruleForm.nome,
            email: this.ruleForm.email,
            password: this.ruleForm.pass,
            password_confirmation: this.ruleForm.checkPass,
          };
          if (this.ruleForm.pass != this.ruleForm.checkPass) {
            this.$notify({
              title: "Erro",
              message:
                "Erro ao cadastrar os dados! Informe a senha correatamente!",
              type: "error",
            });
            this.ruleForm.pass = "";
            this.ruleForm.checkPass = "";
            return false;
          }
          const userId = this.usuario.id_usuario || 0;
          // console.log("userId2: " + userId);
          axios
            .put(url + "/users/" + userId, dados, {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
              },
            })
            .then(() => {
              this.$notify({
                title: "Sucesso",
                message: "Registro Salvo com sucesso!",
                type: "success",
              });

              this.ruleForm.pass = "";
              this.ruleForm.checkPass = "";
            })
            .catch((err) => {
              this.$notify({
                title: "Erro",
                message:
                  "Erro ao cadastrar os dados! Tente novamente mais tarde!" +
                  err,
                type: "error",
              });

              this.ruleForm.pass = "";
              this.ruleForm.checkPass = "";
            });
        } else {
          this.$message({
            type: "info",
            message: "Informe os dados corretamente!",
          });
          return false;
        }
      });
    },
    //FIM CADASTRO DADOS
  },
};
</script>